import { z } from "zod";
import { wishlistMetadata } from "./wishlistMeta";
import { wishlistTag } from "./wishlistTag";

export const wishlistTags = z.object({
  tags: z.array(wishlistTag),
  metadata: wishlistMetadata,
});

export type WishlistTags = z.infer<typeof wishlistTags>;
